
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tblInvAdjustmentDetail/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblInvAdjustmentDetail/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblInvAdjustmentDetail/findPage',
        method: 'post',
      data
    })
}

// 查询重复的行号
export const findDuplicateLine = (data) => {
  return axios({
    url: '/tblInvAdjustmentDetail/findDuplicateLine',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblInvAdjustmentDetail.js